import { render, staticRenderFns } from "./friendTransfer.vue?vue&type=template&id=36b4fcb7&scoped=true&"
import script from "./friendTransfer.vue?vue&type=script&lang=js&"
export * from "./friendTransfer.vue?vue&type=script&lang=js&"
import style0 from "./friendTransfer.vue?vue&type=style&index=0&id=36b4fcb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4fcb7",
  null
  
)

export default component.exports